/**
 * Static HTML scaffold required by the gizmoGrid jQuery plugin.
 * gizmoGrid's base.init() expects these DOM elements to exist inside the host
 * element before the plugin is initialized. Converted from the legacy AngularJS
 * grid-standard-tpl.html, stripped of ng-* / uib-* / dnd-* attributes.
 */
export const GRID_SCAFFOLD_HTML = `
<div class="gg-alert-container"></div>

<div class="gg-tools">
  <div class="pull-left">
    <ul class="gg-tools-ul">
      <li class="tools-action" action="full-screen" title="full screen"><i class="fa fa-arrows-alt"></i></li>

      <li class="tools-action gt-col-temp-drop" action="show-hide" title="open column settings">
        <i class="fa fa-eye" style="margin-right:3px"></i>
      </li>

      <li class="gt-col-temp-drop">
        <a href="#" class="dropdown-toggle" data-toggle="dropdown"><i style="margin-right:3px" class="fa fa-caret-square-o-down"></i></a>
        <ul class="dropdown-menu" id="gg-template-select"></ul>
      </li>

      <li class="tools-export">
        <a href="#" class="dropdown-toggle" data-toggle="dropdown">
          <i style="margin-right:3px" class="fa fa-file"></i>Export to Excel</a>
        <ul class="dropdown-menu">
          <li class="gg-export-action" action="export"><a href="#"> Download All Data</a></li>
          <li class="gg-export-action" action="filtered-export" style="display:none"><a href="#"> Download Filtered Data</a></li>
        </ul>
      </li>

      <li id="actionsCreate" class="tools-action gt-col-temp-drop gt-grid-action" action="manage-actions">
        <a><i class="fa fa-crosshairs" style="margin-right:3px"></i>Create Grid Action</a>
      </li>

      <li id="actionsMenu" class="grid-actions">
        <a href="#" class="dropdown-toggle" data-toggle="dropdown">
          <i style="margin-right:3px" class="fa fa-crosshairs"></i>Grid Actions<span id="selectedActMenuItem"></span><i style="margin-left:3px" class="fa fa-caret-down"></i></a>
        <ul id="actionsDropMenu" class="dropdown-menu"></ul>
      </li>

      <li class="tools-comments">
        <a href="#" class="dropdown-toggle" data-toggle="dropdown">
          <i style="margin-right:3px" class="fa fa-commenting"></i>Comments</a>
        <ul class="dropdown-menu">
          <li class="gg-comment-display" action="all"><a href="#"><i class="fa fa-check"></i> All Messages</a></li>
          <li class="gg-comment-display" action="notified"><a href="#"><i class="fa fa-check"></i> Yours and Notified</a></li>
          <li class="gg-comment-display" action="yours"><a href="#"><i class="fa fa-check"></i> Only Your</a></li>
          <li class="gg-comment-display" action="none"><a href="#"><i class="fa fa-check"></i> None</a></li>
          <li class="divider"></li>
          <li class="gg-comment-filter" action="filter"><a href="#"><i class="fa fa-filter"></i> <i class="fa fa-times" style="display:none"></i> Filter On Comments</a></li>
        </ul>
      </li>

      <li class="tools-attachments">
        <a href="#" class="dropdown-toggle" data-toggle="dropdown">
          <i style="margin-right:3px" class="fa fa-paperclip"></i>Attachments</a>
        <ul class="dropdown-menu">
          <li class="gg-attachment-display" action="allAttach"><a href="#"><i class="fa fa-check"></i> All Attachments</a></li>
          <li class="gg-attachment-display" action="none"><a href="#"><i class="fa fa-check"></i> None</a></li>
          <li class="divider"></li>
          <li class="gg-attachment-filter" action="filter"><a href="#"><i class="fa fa-filter"></i> <i class="fa fa-times" style="display:none"></i> Filter On Attachments</a></li>
        </ul>
      </li>

      <li class="tools-action" action="expand-cols" title="expand columns to fit text"><i class="fa fa-columns"></i></li>
      <li class="tools-action" action="new-window" title="open in a new window"><i class="fa fa-window-restore"></i></li>

      <li>
        <a href="#" class="dropdown-toggle" data-toggle="dropdown"><i style="margin-right:3px" class="fa fa-paint-brush"></i><i class="fa fa-caret-down"></i></a>
        <ul class="dropdown-menu">
          <div class="color-drop">
            <li class="color-row">
              <div class="tools-action" action="highlight" color="none"><div style="margin-right:5px" class="color-block no-fill"></div> Clear Fill</div>
            </li>
            <li class="color-row">
              <div class="color-block dark-red tools-action" action="highlight" color="dark-red"></div>
              <div class="color-block red tools-action" action="highlight" color="red"></div>
              <div class="color-block green tools-action" action="highlight" color="green"></div>
              <div class="color-block pink tools-action" action="highlight" color="pink"></div>
              <div class="color-block yellow tools-action" action="highlight" color="yellow"></div>
              <div class="color-block blue tools-action" action="highlight" color="blue"></div>
            </li>
          </div>
        </ul>
      </li>

      <li id="batch-actions" class="tools-action hover-on">
        <a href="#" class="dropdown-toggle gg-hide-show-col" data-toggle="dropdown"><i style="margin-right:3px" class="fa fa-gear"></i> actions <i class="fa fa-caret-down"></i></a>
        <ul id="gg-modal-actions" class="dropdown-menu gg-action-list"></ul>
      </li>

      <li id="collpase-expand" class="tools-action" action="expand-collapse-pivot">
        <a><i class="fa fa-crosshairs" style="margin-right:3px"></i>Expand/Collapse</a>
      </li>

      <li class="gg-override-filter" action="filter">
        <a href="#">
          <i class="fa fa-filter"></i>
          <i class="fa fa-times" style="display:none"></i>
          Filter On Overrides
        </a>
      </li>

      <li class="deleteCountContainer">
        <div class="delete-count"></div>
      </li>
    </ul>
  </div>

  <div class="pull-right">
    <div class="gg-search-holder">
      <i class="fa fa-search"></i>
      <input type="text" class="gg-global-search" name="global-search">
      <i class="fa fa-times gg-clear-search"></i>
    </div>
  </div>
</div>

<div class="gg-header">
  <div class="overflow">
    <div class="header-end-cap"></div>
    <div class="gg-header-left-col"></div>
    <div class="gg-header-right-col"></div>
  </div>
</div>

<div class="gg-body" tabindex="1">
  <div class="gg-left-col"></div>
  <div class="gg-right-col"></div>
  <div class="gg-vScroll">
    <div class="gg-vScroll-container">
      <div class="vScroll-track">
        <div class="vScroll-dragger"></div>
      </div>
      <div class="v-scroll-btns">
        <div class="gg-btn btn-scroll-up"><i class="fa fa-caret-up"></i></div><div class="gg-btn btn-scroll-down"><i class="fa fa-caret-down"></i></div>
      </div>
    </div>
  </div>
</div>

<div class="gg-hScroll">
  <div class="gg-hScroll-container">
    <div class="hScroll-track">
      <div class="hScroll-dragger"></div>
    </div>
    <div class="h-scroll-btns">
      <div class="gg-btn btn-scroll-left"><i class="fa fa-caret-left"></i></div><div class="gg-btn btn-scroll-right"><i class="fa fa-caret-right"></i></div>
    </div>
  </div>
</div>

<div class="gg-footer">
  <div class="gg-footer-filters">
    <div class="filter-icon"><i class="fa fa-filter"></i></div>
    <div class="gg-filter-container">
      <div class="gg-clear-all"><i class="fa fa-times"></i></div>
      <div class="filter-item"><div class="gg-clear-item"><i class="fa fa-times"></i></div></div>
    </div>
  </div>
  <div class="gg-footer-details">
    <div class="footer-details"> </div>
    <div class="footer-go-to">Line Number: <input class="go-to-input" type="text" value=""></div>
    <div class="footer-total"><div class="pull-left gg-total-text"></div></div>
  </div>
</div>
`;
